function getLanguage(lang, axiosClient) {
  return new Promise((resolve, reject) => {
    axiosClient.$loadCookieConsentStrings(lang).then((r) => {
      resolve({
        consentModal: {
          title: r.cc_consent_title,
          description: r.cc_consent_description,
          acceptAllBtn: r.cc_consent_accept_all_btn,
          acceptNecessaryBtn: r.cc_consent_reject_all_btn,
          showPreferencesBtn: r.cc_consent_manage_btn,
          footer: r.cc_consent_footer
        },

        preferencesModal: {
          title: r.cc_pref_title,
          acceptAllBtn: r.cc_pref_accept_all_btn,
          acceptNecessaryBtn: r.cc_pref_reject_all_btn,
          savePreferencesBtn: r.cc_pref_save_btn,
          closeIconLabel: r.cc_pref_close_label,
          sections: [
            {
              title: r.cc_pref_intro_title,
              description: r.cc_pref_intro_description
            },

            // ── Strictly necessary ──────────────────────────────────────────
            {
              title: r.cc_necessary_title,
              description: r.cc_necessary_description,
              linkedCategory: 'necessary',
              cookieTable: {
                headers: {
                  name: r.table_label_name,
                  domain: r.table_label_domain,
                  expiration: r.table_label_expiration,
                  desc: r.table_label_desc
                },
                body: r.cc_necessary_cookies
              }
            },

            // ── Analytics ───────────────────────────────────────────────────
            {
              title: r.cc_analytics_title,
              description: r.cc_analytics_description,
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: r.table_label_name,
                  domain: r.table_label_domain,
                  expiration: r.table_label_expiration,
                  desc: r.table_label_desc
                },
                body: r.cc_analytics_cookies
              }
            },

            // ── Marketing ───────────────────────────────────────────────────
            {
              title: r.cc_marketing_title,
              description: r.cc_marketing_description,
              linkedCategory: 'marketing',
              cookieTable: {
                headers: {
                  name: r.table_label_name,
                  domain: r.table_label_domain,
                  expiration: r.table_label_expiration,
                  desc: r.table_label_desc
                },
                body: r.cc_marketing_cookies
              }
            }
          ]
        } 
      });
    });
  });
}



export default function (axiosClient, currentLang) {
  return {
    default: currentLang,
    translations: {
      de: () => {
        return getLanguage('de', axiosClient);
      },
      fr: () => {
        return getLanguage('fr', axiosClient);
      },
      it: () => {
        return getLanguage('it', axiosClient);
      }
    }
  };
}
